// extracted by mini-css-extract-plugin
export default {"Wrapper":"NotFound_Wrapper__Gi2ax","NotFoundIcon":"NotFound_NotFoundIcon__ZuC-5","Text":"NotFound_Text__WI1pT"};